<template>
  <div class="w-full mb-4">
    <div class="flex flex-wrap justify-evenly -ml-1 text-lg leading-loose">
      <div class="flex-1 mb-1 pl-1">
        <v-button disabled class="border-none w-full whitespace-no-wrap bg-white" icon="far fa-tag">
          Produktauswahl
        </v-button>
      </div>
      <div class="flex-1 mb-1 pl-1">
        <v-button
          :active="tabIndex == 1"
          class="border-none w-full whitespace-no-wrap bg-white"
          icon="far fa-list"
          @click="tabIndex = 1"
        >
          Stammdaten
        </v-button>
      </div>
      <div class="flex-1 mb-1 pl-1">
        <v-button
          :active="tabIndex == 2"
          class="border-none w-full whitespace-no-wrap bg-white"
          icon="far fa-hand-holding-box"
          @click="tabIndex = 2"
        >
          {{ __('Zusatzdienste') }}
        </v-button>
      </div>
      <div class="flex-1 mb-1 pl-1">
        <v-button
          :active="tabIndex == 3"
          class="border-none w-full whitespace-no-wrap bg-white"
          icon="far fa-check"
          @click="tabIndex = 3"
        >
          Bestätigen
        </v-button>
      </div>
    </div>
    <!-- tabIndex == 1 -->
    <div v-if="tabIndex == 1">
      <div class="w-full bg-white p-4 border-b">
        <div class="mx-auto w-full max-w-lg">
          <h1 class="mb-6">
            <span class="fas fa-address-card pr-2"></span>
            Brancheneintrag
          </h1>

          <div class="mb-6">
            <label class="text-sm" for="name"
              >{{ __('Name der Einrichtung / des Unternehmens') }}
              <abbr class="text-red-500" :title="__('Pflichtfeld')">*</abbr>
            </label>
            <input
              class="input-text"
              id="name"
              type="text"
              name="name"
              :placeholder="__('Name der Einrichtung / des Unternehmens')"
              required
              autofocus
            />
          </div>

          <div class="mb-6">
            <label for="venue" class="text-sm">Adresse<abbr class="text-red-500" title="Pflichtfeld">*</abbr> </label>
            <geo-search id="venue" name="venue"></geo-search>
          </div>

          <div class="mb-6">
            <div>
              <label class="text-sm" for="address_supplement">
                {{ __('Adresszusatz') }}
              </label>
              <input
                dusk="location-create-address-supplement"
                type="text"
                class="input-text"
                name="address_supplement"
                id="address_supplement"
                placeholder="optionale Zusatzinformationen zur Adresse"
              />
            </div>
          </div>

          <div class="mb-6">
            <label for="contact_person" class="text-sm">
              {{ __('Kontaktperson') }}
              <abbr class="text-red-500" title="Pflichtfeld">*</abbr>
            </label>
            <input
              type="text"
              name="contact_person"
              class="input-text"
              :placeholder="__('institution.booking_billing_contact_person_name_placeholder')"
              required
            />
          </div>

          <div class="mb-6">
            <div>
              <label class="text-sm" for="phone_number">
                {{ __('Telefon') }}
                <abbr class="text-red-500" title="Pflichtfeld">*</abbr>
              </label>
              <input
                class="input-text"
                id="phone_number"
                type="number"
                name="phone_number"
                required
                placeholder="Telefon"
              />
            </div>
          </div>

          <div class="mb-6">
            <div>
              <label class="text-sm" for="email"
                >{{ __('E-Mail-Adresse') }}
                <abbr class="text-red-500" title="Pflichtfeld">*</abbr>
              </label>
              <input class="input-text" id="email" type="email" name="email" required />
            </div>
          </div>
        </div>
      </div>

      <div class="w-full bg-white p-4 border-b">
        <div class="mx-auto w-full max-w-lg">
          <div class="my-6">
            <input
              type="checkbox"
              class="absolute opacity-0"
              name="same_billing_adresse"
              @click="setSameAddress($event.target.checked)"
              id="same_billing_adresse"
              :checked="same_adresse"
            />
            <span class="hide-on-checked text-xl text-blue-200 fa fa-square" aria-hidden="true"></span>
            <span class="visible-on-checked text-xl text-green-500 fa fa-check-square" aria-hidden="true"></span>
            <label for="same_billing_adresse" class="mb-2">
              <span class="ml-1" v-html="__('Rechnungsadresse ist identisch')"></span>
            </label>
          </div>
          <div v-if="!same_adresse">
            <h3 class="mb-6">{{ __('Rechnungsanschrift eingeben') }}</h3>
            <div class="mb-6">
              <label for="company" class="text-sm"
                >{{ __('Name der Einrichtung / des Unternehmens')
                }}<abbr class="text-red-500" title="Pflichtfeld">*</abbr>
              </label>
              <input
                type="text"
                name="company"
                class="input-text"
                :placeholder="__('Name der Einrichtung / des Unternehmens')"
                required
              />
            </div>

            <div class="mb-6">
              <label for="venue" class="text-sm"
                >{{ __('Adresse') }}<abbr class="text-red-500" title="Pflichtfeld">*</abbr>
              </label>
              <geo-search id="venue" name="venue"> </geo-search>
            </div>

            <div class="mb-6">
              <label for="contact_person" class="text-sm">
                {{ __('Kontaktperson') }}
                <abbr class="text-red-500" title="Pflichtfeld">*</abbr>
              </label>
              <input
                type="text"
                name="contact_person"
                class="input-text"
                :placeholder="__('Vor- und Nachname der Kontaktperson')"
                required
              />
            </div>

            <div class="mb-6">
              <label for="phone_number" class="text-sm">
                {{ __('Telefonnummer') }}
                <abbr class="text-red-500" title="Pflichtfeld">*</abbr>
              </label>
              <input type="number" name="phone_number" class="input-text" :placeholder="__('Telefonnummer')" required />
            </div>

            <div class="mb-6">
              <label for="email" class="text-sm">
                {{ __('E-Mail-Adresse') }}
                <abbr class="text-red-500" title="Pflichtfeld">*</abbr>
              </label>
              <input type="email" name="email" class="input-text" :placeholder="__('E-Mail-Adresse')" required />
            </div>
          </div>
        </div>
      </div>
      <div class="w-full bg-white p-4 border-b">
        <div class="flex justify-end">
          <v-button @click="tabIndex++">
            {{ __('booking_order_con') }}
          </v-button>
        </div>
      </div>
    </div>
    <!-- tabIndex == 2 -->
    <div v-if="tabIndex == 2">
      <div class="w-full bg-white p-4 border-b">
        <div class="mx-auto w-full max-w-lg">
          <h1 class="mb-6">Zuätzliche Informationen für Ihren Eintrag auf bremen.de</h1>

          <p class="mb-4" v-html="__('institution.booking_order_zusatzinfos_text')"></p>

          <category-selection-app></category-selection-app>
        </div>
      </div>
      <div class="w-full bg-white p-4 border-b">
        <div class="mx-auto w-full max-w-lg">
          <fieldset>
            <h3 class="mb-4">
              {{ __('Zusatzdienste') }}
            </h3>

            <div class="mb-4">
              <label for="barrierefreie_informationen" class="mb-2">
                <input
                  type="checkbox"
                  class="absolute opacity-0"
                  name="barrierefreie_informationen"
                  id="barrierefreie_informationen"
                />
                <span class="hide-on-checked text-xl text-blue-200 fa fa-square" aria-hidden="true"></span>
                <span class="visible-on-checked text-xl text-green-500 fa fa-check-square" aria-hidden="true"></span>
                <span class="ml-1" v-html="__('institution.booking_order_barrierefreie_informationen')"></span>
              </label>
            </div>

            <div class="mb-4">
              <label for="regis_online" class="mb-2">
                <input type="checkbox" class="absolute opacity-0" name="regis_online" id="regis_online" />
                <span class="hide-on-checked text-xl text-blue-200 fa fa-square" aria-hidden="true"></span>
                <span class="visible-on-checked text-xl text-green-500 fa fa-check-square" aria-hidden="true"></span>
                <span class="ml-1" v-html="__('institution.booking_order_regis_online')"></span>
              </label>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="w-full bg-white p-4 border-b">
        <div class="flex justify-end">
          <v-button @click="tabIndex++">Weiter</v-button>
        </div>
      </div>
    </div>
    <!-- tabIndex == 3 -->
    <div v-if="tabIndex == 3" class="w-full bg-white p-4">
      <div class="flex flex-wrap mb-4">
        <div class="md:pr-2 md:w-1/2 w-full">
          <!-- item to buy -->
          <div class="flex h-full items-center justify-center relative border-b md:border-r hover:bg-gray-100 p-4">
            <v-button small class="border-none absolute right-0 top-0" icon="far fa-pen"></v-button>
            <h1 class="text-center">
              <span class="block fa-2x far pr-2 pb-2 fa-address-card"></span>Brancheneintrag Premium
            </h1>
          </div>
        </div>
        <div class="md:pl-2 md:w-1/2 w-full">
          <!-- billing address -->
          <div class="border-b hover:bg-gray-100 p-4 relative">
            <v-button small class="border-none absolute right-0 top-0" icon="far fa-pen"></v-button>
            <h3 class="mb-2"><span class="far fa-map-marker-alt pr-2"></span>Rechnungsanschrift</h3>
            <div class="ml-6">
              Rosa Luxemburg <br />
              Knochenhauerstraße 20-25, <br />
              Adresszusatz der den Bremen
            </div>
          </div>
          <!-- payment method -->
          <div class="border-b hover:bg-gray-100 p-4 relative">
            <v-button small class="border-none absolute right-0 top-0" icon="far fa-pen"></v-button>
            <h3 class="mb-2"><span class="far fa-money-check-edit-alt pr-2"></span>Zahlungsart</h3>
            <img class="h-10" src="/svg/paypal.svg" alt="PayPal" />
          </div>
        </div>
      </div>
      <div class="flex flex-wrap">
        <div class="md:w-1/2 w-full"></div>
        <div class="md:pl-2 md:w-1/2 w-full pt-4">
          <div class="mb-8">
            <div class="flex justify-between">
              <div>Preis</div>
              <div>49,00€</div>
            </div>
            <div class="flex justify-between mb-2">
              <div>19% MwSt.</div>
              <div>9,31€</div>
            </div>
            <div class="flex justify-between font-bold text-lg">
              <div>Gesamtpreis</div>
              <div>58,31€</div>
            </div>
          </div>

          <div class="mb-8">
            <input
              type="checkbox"
              class="absolute opacity-0"
              name="ich-stimme-den-teilnahmebedingungen-zu"
              id="ich-stimme-den-teilnahmebedingungen-zu"
              v-model="accept_terms"
              required
            />
            <span class="hide-on-checked text-xl text-blue-200 fa fa-square" aria-hidden="true"></span>
            <span class="visible-on-checked text-xl text-green-500 fa fa-check-square" aria-hidden="true"></span>
            <label for="ich-stimme-den-teilnahmebedingungen-zu" class="mb-2">
              <span class="ml-1"> Ich stimme den Teilnahmebedingungen zu.</span>
              <abbr class="text-red-500" title="Pflichtfeld">*</abbr>
            </label>
          </div>
          <v-button class="float-right" :disabled="!accept_terms">Bestellen</v-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      accept_terms: false,
      tabIndex: 2,
      same_adresse: true,
    };
  },
  methods: {
    setSameAddress(bool) {
      this.same_adresse = bool;
    },
  },
};
</script>
